
import React from 'react';
import { SocialShareButtons } from './SocialShareButtons';

interface BlogPostFooterProps {
  title: string;
  url: string;
  description: string;
  image: string;
}

export function BlogPostFooter({ title, url, description, image }: BlogPostFooterProps) {
  return (
    <div className="my-6 social-share">
      <SocialShareButtons 
        title={title} 
        url={url}
        description={description}
        image={image}
      />
    </div>
  );
}
